<template>
  <div>
    <label :for="name" class="inline-flex text-sm font-medium leading-6">
      {{ label }}
      <div v-if="required" class="text-pink-600">*</div>
    </label>
    <input
      :id="name"
      :type="type"
      :name="name"
      :placeholder="placeholder"
      class="block w-full rounded-md border-0 py-3 px-4 text-neutral-800 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-pink-600 focus-visible:outline-none sm:text-sm sm:leading-6"
      :class="{
        '': true,
      }"
      :required="required"
      v-model="inputValue"
      @input="handleInput"
      @blur="handleBlur"
      @change="handleChange"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
    },
    type: {
      type: String,
      default: "text",
    },
    name: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    required: Boolean,
  },

  data() {
    return {
      inputValue: this.value,
    };
  },

  watch: {
    value(newValue) {
      this.inputValue = newValue;
    },
    inputValue(newValue) {
      this.$emit("input", newValue);
    },
  },

  methods: {
    handleInput(e) {
      this.$emit("input", e.target.value);
    },
    handleBlur() {
      this.$emit("blur");
    },
    handleChange(e) {
      this.$emit("change", e.target.value);
    },
  },
};
</script>
